import theme from '@styles/theme';
export default {
  priceArea: {
    pt: '10px'
  },
  priceRow: {
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    columnGap: '8px',
    rowGap: '4px'
  },
  productCardInfoPrice: (isPromo = false) => ({
    fontFamily: theme.fonts.uniformExtra,
    letterSpacing: '0.05em',
    fontSize: theme.fontSizes.bigText,
    color: isPromo ? theme.rawColors.accent700 : theme.rawColors.neutralBlack,
    span: {
      textWrap: 'nowrap'
    },
    small: {
      color: theme.rawColors.omnibus,
      fontSize: theme.fontSizes.smallText,
      ml: '4px',
      position: 'relative',
      textWrap: 'nowrap',
      '&:after': {
        content: '""',
        position: 'absolute',
        height: '1px',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        background: theme.rawColors.darkGrey300,
        width: '100%'
      }
    }
  }),
  priceLink: (isPromo = false) => ({
    fontFamily: theme.fonts.uniformExtra,
    letterSpacing: '0.05em',
    fontSize: theme.fontSizes.bigText,
    textDecoration: 'none',
    outline: 'none',
    '&&': {
      color: isPromo ? theme.rawColors.accent700 : theme.rawColors.neutralBlack
    },
    '&:visited': {
      color: isPromo ? theme.rawColors.accent700 : theme.rawColors.neutralBlack
    },
    '&:hover': {
      textDecoration: 'underline'
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.rawColors.blue500}`,
      outlineOffset: '2px'
    },
    span: {
      textWrap: 'nowrap'
    },
    small: {
      color: theme.rawColors.omnibus,
      fontSize: theme.fontSizes.smallText,
      ml: '4px',
      position: 'relative',
      textWrap: 'nowrap',
      '&:after': {
        content: '""',
        position: 'absolute',
        height: '1px',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        background: theme.rawColors.darkGrey300,
        width: '100%'
      }
    }
  }),
  omnibus: {
    width: '100%'
  },
  technicalCard: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '4px',
    width: '100%',
    fontSize: theme.fontSizes.omnibus,
    textDecoration: 'underline'
  },
  gpsr: {
    position: 'absolute',
    width: '43px',
    height: '24px',
    top: 0,
    right: 0,
    zIndex: theme.zIndex.documentHigh
  }
};